import { Key as KeyIcon, Lock as LockIcon, Shield as ShieldIcon } from '@mui/icons-material';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            color: 'white',
            py: 6,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 3,
            }}
          >
            <KeyIcon sx={{ fontSize: 64, mr: 1 }} />
            <Typography variant="h2" component="h1" fontWeight={700}>
              AmnPass
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
            Zero-knowledge password manager
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 6 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/signup')}
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                '&:hover': { bgcolor: 'grey.100' },
                px: 4,
              }}
            >
              Get Started
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate('/login')}
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': { borderColor: 'grey.200', bgcolor: 'rgba(255,255,255,0.1)' },
                px: 4,
              }}
            >
              Sign In
            </Button>
          </Stack>

          <Stack spacing={3} alignItems="center">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <LockIcon />
              <Typography>End-to-end encrypted - we can't read your data</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <ShieldIcon />
              <Typography>Secure sharing with public-key cryptography</Typography>
            </Box>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

